import { Box, Typography } from "@material-ui/core";
import dayjs from "dayjs";
import { Icon, IconName } from "halifax";
import React from "react";
import clsx from "clsx";

import "./styles.scss";
import { OUTBOUND, RETURN } from "./textConstants";

const DateWrapper = ({ label, value }: { label: string; value?: string }) => (
  <Box className="selected-date-wrapper">
    <Icon name={IconName.Calendar} />
    <Box className="selected-date-content">
      <Typography className="content-top-label">
        {value ? label : ""}
      </Typography>
      <Typography className={clsx("content-main-content", { label: !value })}>
        {value || label}
      </Typography>
    </Box>
  </Box>
);

interface IMobileSelectedDatesDisplayProps {
  departureDate: Date | null;
  returnDate: Date | null;
}
export const MobileSelectedDatesDisplay = ({
  departureDate,
  returnDate,
}: IMobileSelectedDatesDisplayProps) => (
  <Box className="selected-dates-display-root">
    <DateWrapper
      label={OUTBOUND}
      value={
        departureDate ? dayjs(departureDate).format("ddd, MMM D") : undefined
      }
    />
    <DateWrapper
      label={RETURN}
      value={returnDate ? dayjs(returnDate).format("ddd, MMM D") : undefined}
    />
  </Box>
);
